import { useMemo } from 'react'

import { PARAMS } from './components/constants'

export const GTM_SEND_TO = 'AW-948897618/uUwjCKCpl4MBENKOvMQD'

export const useExtractParams = (searchString: string) =>
    useMemo(() => {
        const urlParams = new URLSearchParams(searchString)
        const paramsObj: { [key: string]: string | null } = {}

        PARAMS.forEach(param => (paramsObj[param] = urlParams.get(param)))

        return paramsObj
    }, [searchString])
